import React from "react";
import { Add, AssignmentOutlined, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Badge, Box, Button, Typography } from "@mui/material";
import FormDrawer from "components/Shared/FormDrawer";
import { toast } from "react-toastify";
import {
    useAddNoteSourceMutation,
    useGetNoteVendorLeadTaskBySourceQuery,
    useUpdateNoteByIdMutation,
} from "store/services/noteApi";
import BasicNoteForm from "../../Note/BasicNoteForm";
import NoteList from "../../Note/NoteList";

const VendorLeadTaskTab = ({ sourceRef }) => {
    const [selectedTask, setSelectedTask] = React.useState(null);
    const [showReplies, setShowReplies] = React.useState(true);

    const { data } = useGetNoteVendorLeadTaskBySourceQuery(
        { sourceRef },
        { skip: !sourceRef }
    );

    const [addNoteSource, { isLoading: addingTask }] = useAddNoteSourceMutation();
    const [updateNoteById, { isLoading: updatingTask }] = useUpdateNoteByIdMutation();

    const handleAddTask = async (data) => {
        try {
            await addNoteSource({
                ...data,
                source: "VendorLeadTask",
                sourceRef,
            }).unwrap();
            toast.success("Task successfully assigned!");
            setSelectedTask(null);
        } catch (err) {
            toast.error(err?.data?.message ?? "Couldn't assign task!");
        }
    };

    const handleUpdateTask = async (data) => {
        try {
            await updateNoteById({
                ...data,
                noteId: data._id,
                source: "VendorLeadTask",
                sourceRef,
            }).unwrap();
            toast.success("Task successfully updated!");
            setSelectedTask(null);
        } catch (err) {
            toast.error(err?.data?.message ?? "Couldn't update task!");
        }
    };

    return (
        <Box>
            <Box
                display="flex"
                alignItems="end"
                justifyContent="space-between"
                padding={3}
            >
                <Box display="inline-flex" alignItems="center" gap={1.5}>
                    <Badge color="primary">
                        <AssignmentOutlined style={{ color: "gray" }} />
                    </Badge>
                    <Typography style={{ fontWeight: 500 }}>Tasks</Typography>
                </Box>
                <Box>
                    <Button
                        startIcon={<Add />}
                        variant="outlined"
                        onClick={() => setSelectedTask(true)}
                    >
                        Assign Action Tasks
                    </Button>
                    <Button
                        sx={{ marginLeft: "20px" }}
                        startIcon={showReplies ? <ExpandLess /> : <ExpandMore />}
                        variant="outlined"
                        onClick={() => setShowReplies((prev) => !prev)}
                    >
                        {showReplies ? "Hide Replies" : "Show Replies"}
                    </Button>
                </Box>
            </Box>
            <NoteList
                notes={data || []}
                onCommentEdit={(task) => setSelectedTask(task)}
                showReplies={showReplies}
            />
            <FormDrawer
                title="Assign Action Tasks"
                open={!!selectedTask}
                onClose={() => setSelectedTask(null)}
            >
                <BasicNoteForm
                    isBusy={updatingTask || addingTask}
                    noteDetail={selectedTask === true ? null : selectedTask}
                    showResponsible={true}
                    onSubmit={(data) =>
                        selectedTask && selectedTask !== true
                            ? handleUpdateTask(data)
                            : handleAddTask(data)
                    }
                    onCancel={() => setSelectedTask(null)}
                    isShowClient={false}
                    source="VendorLeadTask"
                />
            </FormDrawer>
        </Box>
    );
};

export default VendorLeadTaskTab;